var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeletonLoadingImage"},[_c('img',{staticClass:"mainImage",class:{
			'mainImage--contain': _vm.imageContain,
			'mainImage--cover': _vm.imageCover,
		},attrs:{"src":_vm.imageSrcBase64,"alt":""},on:{"click":_vm.onImageClick,"load":_vm.onImageLoaded,"error":_vm.onImageLoadError}}),(_vm.imageSrc && _vm.isShowSkeletonLoading)?_c('ProcessingSpinner',{staticClass:"skeletonSpinner"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }